import { createRef, h, render } from "preact"
import debounce from "debounce";
import { Connect, Provider } from "redux-zero/preact";
import { searchStore } from "./store";
import searchActions from "./searchActions";
import { useCallback, useEffect, useState } from "preact/hooks";
import { fetchSearchSuggestion } from "Scripts/utils";


export const SearchForm = ({setSearchSuggestion, setIsFetching, suggestionQuery, setSuggestionQuery, setIsSuggestionFetching}) => {
  const [q, setQuery] = useState('');
  const ref = createRef();
  
  useEffect(() => {
    if (suggestionQuery && suggestionQuery !== q) {
      setQuery(suggestionQuery);
      ref.current.value = suggestionQuery;
      ref.current.dispatchEvent(new Event('input'));
      setSuggestionQuery('')
    }
  }, [suggestionQuery])
  
  const handleOnFocus = (e) => {
    if (q.trim()) {
      document.body.classList.add('search-drop--active');
    }
  }
  
  const goToSearchResults = (e) => {
    e.preventDefault();
    location.href = `/search?q=${q}`
  }
  
  const handleInput = useCallback(async (e) => {
    const q = e.target.value
    setQuery(q)
    toggleSearchDrop(q);
    updateSuggestionData(q);
  }, [])
  
  function toggleSearchDrop(q) {
    if (q.trim()) {
      document.body.classList.add('search-drop--active');
    } else {
      document.body.classList.remove('search-drop--active');
    }
  }
  
  function updateSuggestionData(q) {
    setIsFetching(true);
    setIsSuggestionFetching(true)
    fetchSearchSuggestion(q).then((response) => {
      setSearchSuggestion({...response, isFetching: false});
      setIsFetching(false);
      setIsSuggestionFetching(false);
    });
  }
  
  
  
  return (
    <form class="site-search-form" onSubmit={goToSearchResults}>
      <div class="site-search-form__row position-relative d-flex align-items-center">
        <button type="submit" class="site-search-form__button"
                dangerouslySetInnerHTML={ {__html: theme.icons.search} }/>
        <input ref={ ref } type="text" placeholder="Search" class="site-search-form__input" value={ q }
               onfocus={ handleOnFocus }
               onclick={ handleOnFocus }
               oninput={ handleInput }/>
      </div>
    </form>
  )
}

const searchForms = document.querySelectorAll('.preact-search-form');
[...searchForms].forEach((searchForm) => {
  render(
    <Provider store={ searchStore }>
      <Connect actions={ searchActions }>
        { ({setSearchSuggestion, setIsFetching, suggestionQuery, setQuery, setIsSuggestionFetching}) => (
          <SearchForm setIsFetching={ setIsFetching }
                      setSuggestionQuery={ setQuery }
                      suggestionQuery={ suggestionQuery }
                      setSearchSuggestion={ setSearchSuggestion }
                      setIsSuggestionFetching={ setIsSuggestionFetching }
                      ref={ (element) => {
                        window.search = element
                      } }/>
        ) }
      </Connect>
    </Provider>, searchForm);
  
})


